<template>
<div class="page page_fans">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
        <div class="list">
            <div class="item" v-for="agent in dataList" :key="agent.agent_uuid">
                <div class="item_l">
                    <img :src="agent.company_photo ? ( $publicData.withHttpStart(agent.company_photo) ? agent.company_photo : imageUrl+agent.company_photo ) : $publicData.defaultTouxiang" alt="" class="thumb">
                    <div class="user_name slh_s">{{ agent.nickname }}</div>
                </div>
            </div>
        </div>
    </van-list>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            dataList: [],
            loading: true,
            finished: false,
            pages: {
                page: 1,
                size: 10
            }
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的二级分销商'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    mounted() {

    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null) {
                return
            }
            var param = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.my.firstAgentIndex(param).then(res => {
                if (res.code == 200) {
                    var list = res.result.agent
                    if (list.length != 0) {
                        for (var i in list) {
                            this.dataList.push(list[i])
                        }
                    } else {
                        this.finished = true
                    }

                } else {
                    this.finished = true
                    this.$toast(res.message)
				}
				this.pages.page++
				this.loading = false
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
